@import "../../../../../shared/styles/base";

#tooltip-container {
  position: absolute;
  left: 0;
  top: 0;
}

.c-popup {
  position: absolute;

  &--hidden {
    visibility: hidden;
  }
}

.close-modal-popup {
  position: absolute;
  overflow: hidden;
  margin: 0;
  width: 1px;
  height: 1px;
  clip-path: inset(100%);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
  border: none;

  &:focus {
    overflow: visible;
    width: auto;
    height: auto;
    clip-path: none;
    clip: auto;
    display: block;
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 11;
    padding: 0.5rem;
    background: $white;
    text-decoration: none;
  }
}
